__turbopack_context__.v({
  "error-message": "vw7LkW_error-message",
  "footer": "vw7LkW_footer",
  "label": "vw7LkW_label",
  "placeholder": "vw7LkW_placeholder",
  "wide": "vw7LkW_wide",
  "wrapper": "vw7LkW_wrapper",
});
